module.exports = __webpack_public_path__ + "static/media/resume-w.51237a53.svg";